import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { css, StyleSheet } from 'aphrodite';

import {
  getURL,
  GLOBAL_VENDOR_BRAND_COVERAGE,
  PRODUCT_LIST_PRODUCT_SCORE,
  PRODUCT_LIST_PRODUCT_P0_SCORE,
} from 'lib/networking/endpoints';
import LoadingSpinner from 'components/shared/LoadingSpinner';
import ProductListScoreCard from 'components/product_lists/product_list/ProductListScoreCard';
import { SwalToast } from 'lib/utils/toast';
import useGet from 'lib/hooks/useGet';
import usePost from 'lib/hooks/usePost';

function ProductListScoreView({ productListId, isDistributorView, globalVendorId }) {
  const [brandCoverageData, setBrandCoverageData] = useState({
    brand_coverage: null,
    presigned_url: null,
  });

  const { data: { fsa_score } = {}, loading } = useGet(
    getURL(PRODUCT_LIST_PRODUCT_SCORE, {
      product_list_id: productListId,
    }),
    {},
    !productListId,
  );
  const { data: { p0_score } = {}, loading: p0_loading } = useGet(
    getURL(PRODUCT_LIST_PRODUCT_P0_SCORE, {
      product_list_id: productListId,
    }),
    {},
    !productListId,
  );

  const { postData: calculateBrandCoverage } = usePost(GLOBAL_VENDOR_BRAND_COVERAGE, res => {
    setBrandCoverageData(res.data);
  });

  useEffect(() => {
    if (globalVendorId) {
      calculateBrandCoverage({ global_vendor_id: globalVendorId, re_calculate_coverage: false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading || p0_loading) {
    return <LoadingSpinner short />;
  }

  return (
    <div className={classNames('d-flex mx-1 p-1', css(styles.cardContainer))}>
      <ProductListScoreCard score={fsa_score} name="CD Product Score" />
      {isDistributorView && <ProductListScoreCard score={p0_score} name="P0 Score" />}
      {globalVendorId && (
        <ProductListScoreCard
          score={brandCoverageData.brand_coverage?.toFixed(2) || '-'}
          name="Catalog Brand Coverage"
          refetch={() => {
            calculateBrandCoverage({
              global_vendor_id: globalVendorId,
              re_calculate_coverage: true,
            });
            SwalToast('success', 'Brand coverage recalculate started');
          }}
          filePath={brandCoverageData.presigned_url}
        />
      )}
    </div>
  );
}

const styles = StyleSheet.create({
  cardContainer: {
    alignItems: 'center',
  },
});

ProductListScoreView.propTypes = {
  productListId: PropTypes.string,
  isDistributorView: PropTypes.bool,
  globalVendorId: PropTypes.number,
};

export default ProductListScoreView;
